import { ArrangementType } from '../models/enums';
import { ILayerComposer, ILayerViewModel, ILayout } from '../models/interfaces';
import { CabreraComposer } from './cabreraComposer';
import { PaperRateComposer } from './paperRateComposer';
import { RelocateComposer } from './relocateComposer';
import { TimeAlignmentComposer } from './timeAlignmentComposer';

export class ArrangementComposer extends RelocateComposer<ArrangementType> {
    // data members

    private paperRateComposer: ILayerComposer;
    private timeAlignmentComposer: ILayerComposer;
    private cabreraComposer: ILayerComposer;

    // constructor

    constructor(layout: ILayout) {
        super(layout, ArrangementType.SixXTwo);

        this.paperRateComposer = new PaperRateComposer(layout);
        this.timeAlignmentComposer = new TimeAlignmentComposer(layout);
        this.cabreraComposer = new CabreraComposer(layout);
    }

    // public functions

    public isChanged() {
        return this.changeDetection.isChanged(this.layout.ecgState.chartState.arrangement);
    }

    // protected functions

    protected onUpdateAll(layers: Array<ILayerViewModel>) {
        super.onUpdateAll(layers);

        this.paperRateComposer.update(layers, true);
        this.timeAlignmentComposer.update(layers, true);
        this.cabreraComposer.update(layers, true);
    }

    protected onUpdate(layer: ILayerViewModel) {
        if (layer.traces.length === 0) {
            return;
        }

        layer.traces.forEach((trace) => {
            trace.visible = true;
            //trace.index = index;
        });

        layer.referenceTraces.forEach((trace) => (trace.visible = false));

        switch (this.layout.ecgState.chartState.arrangement) {
            case ArrangementType.SixXTwo:
                this.layout.rows = 6;
                this.layout.columns = 2;
                break;
            case ArrangementType.ThreeXFour:
                if (layer.traces.length === 15) {
                    for (let i = 12; i < 15; i++) {
                        layer.traces[i].visible = false;
                    }
                }
                this.layout.rows = 3;
                this.layout.columns = 4;
                layer.referenceTraces.forEach((trace) => (trace.visible = true));
                break;
            case ArrangementType.TwelveXOne:
                this.layout.rows = 12;
                this.layout.columns = 1;

                break;
            case ArrangementType.SixXOnePrecordial:
                this.layout.rows = 6;
                this.layout.columns = 1;
                layer.traces.filter((trace, index) => index < 6).forEach((trace) => (trace.visible = false));
                break;

            case ArrangementType.SixXOnePeripheral:
                this.layout.rows = 6;
                this.layout.columns = 1;
                layer.traces.filter((trace, index) => index >= 6).forEach((trace) => (trace.visible = false));
                break;

            case ArrangementType.Medians:
                this.layout.rows = 3;
                this.layout.columns = 4;
                break;

            case ArrangementType.XXOne:
                this.layout.rows = layer.traces.length;
                this.layout.columns = 1;
                break;

            case ArrangementType.XXTwo:
                this.layout.rows = Math.ceil(layer.traces.length / 2);
                this.layout.columns = 2;
                break;
        }

        this.layout.updateLeadWidth();

        super.onUpdate(layer);
    }
}
